import Component from './component.vue';
export default Component;



// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/index.js